module.exports = __webpack_public_path__ + "static/ToolkitLandingImg3-ada06fe2cc51d9190cabca83c7b832d1.png";